var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@font-face {\n  font-family: 'OPPOSans';\n  src: url(" + escape(require("./assets/Font-OPPOSans/OPPOSans-M.ttf")) + ") format('truetype'); /* 相对路径指向TTF文件 */\n  font-weight: normal;\n  font-style: normal;\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shuan-finished/shuan-drama-town会昌戏剧小镇/shuan-drama-town-web/vue-drama/src/src/App.vue"],"names":[],"mappings":";AAaA;EACA,wBAAA;EACA,sDAAA,CAAA,iBAAA;EACA,oBAAA;EACA,mBAAA;CACA","file":"App.vue","sourcesContent":["<template>\n  <div id=\"app\">\n    <router-view/>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'App'\n}\n</script>\n\n<style>\n@font-face {\n  font-family: 'OPPOSans';\n  src: url('assets/Font-OPPOSans/OPPOSans-M.ttf') format('truetype'); /* 相对路径指向TTF文件 */\n  font-weight: normal;\n  font-style: normal;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = z/+d
// module chunks = 26